import React, { useMemo, useEffect, useState } from 'react'

import { arrayToObject } from 'utils/functions'

import GenericListItem from 'components_new/molecules/GenericListItem'
import List from 'components_new/atoms/List'

import { getPrivateKpis } from 'redux/api/DashboardGroups'
import { useMetrics } from 'redux/hooks/Metrics'
import StatusBox from 'components_new/molecules/StatusBox'
import { useTranslation } from 'language/translator'

// Used to show private KPIs used in a dashboard
const PrivateKpiStatusBox = (props: { id: string }) => {
  const [privateKpis, setPrivateKpis] = useState<string[]>([])
  const [metrics] = useMetrics()
  const { t, lang } = useTranslation()

  useEffect(() => {
    getPrivateKpis(props.id).then((response) => {
      setPrivateKpis(response.data.data)
    })
  }, [])

  const privateKpisListItems = useMemo(() => {
    const mapper = arrayToObject(metrics)

    return privateKpis
      .filter((kpiId) => kpiId in mapper)
      .map((kpiId) => [
        <GenericListItem
          key={kpiId}
          size="medium"
          title={mapper[kpiId].title[lang]}
          titleIcon={{
            name: 'Private'
          }}
          variant="metric"
        />
      ])
  }, [privateKpis])

  return privateKpis.length > 0 ? (
    <StatusBox
      severity="warning"
      sx={{ mb: 2 }}
      title={'Dashboarden innehåller privata mätetal'}
    >
      {t('dashboards', 'sensitive_metrics_note')}
      <List dense={true}>{privateKpisListItems}</List>
    </StatusBox>
  ) : null
}

export default PrivateKpiStatusBox
